import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaGlobe, FaEnvelope, FaPhone, FaMapMarkerAlt } from "react-icons/fa";
import logo from "../image/USA_transparent (2).png";

const Footer = () => {
  return (
    <footer className="bg-[#151e2e] text-white pt-10 pb-4 px-4 md:px-16 lg:px-32">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 border-b border-gray-700 pb-6">
        {/* Left Section */}
        <div className="flex flex-col gap-2 max-w-xs">
          <div className="flex items-center gap-3 mb-1">
            <div className="bg-[#232f47] rounded-xl p-2 flex items-center justify-center">
              <img src={logo} alt="Universal Science Academy Logo" className="h-10 w-10 object-contain" />
            </div>
            <div>
              <div className="text-xl md:text-2xl font-bold">Universal Science Academy</div>
              <div className="text-gray-300 text-sm">Excellence in Education</div>
            </div>
          </div>
          <div className="flex gap-3 mt-2">
            <a href="https://www.universalscienceacademy.lk" target="_blank" rel="noopener noreferrer" className="bg-[#232f47] p-2 rounded-lg hover:bg-[#22304a] transition"><FaGlobe size={20} /></a>
            <a href="https://www.facebook.com/share/18PtH8Hn9T/" target="_blank" rel="noopener noreferrer" className="bg-[#232f47] p-2 rounded-lg hover:bg-[#22304a] transition"><FaFacebook size={20} /></a>
          </div>
        </div>

        {/* Right Section */}
        <div className="flex-1 flex flex-col md:items-end gap-2">
          <div className="text-lg font-bold mb-1">Contact Info</div>
          <div className="flex items-center gap-2 text-gray-300 text-sm"><FaMapMarkerAlt className="text-blue-400" /> K.K.S Road Chunnakam, 40000</div>
          <div className="flex items-center gap-2 text-gray-300 text-sm"><FaPhone className="text-blue-400" /> 077 996 6888</div>
          <div className="flex items-center gap-2 text-gray-300 text-sm"><FaEnvelope className="text-blue-400" /> <a href="mailto:universalscienceacademyjaffna@gmail.com" className="hover:underline text-blue-200">universalscienceacademyjaffna@gmail.com</a></div>
        </div>
      </div>

      {/* Bottom Row */}
      <div className="flex flex-col md:flex-row justify-between items-center mt-4 text-gray-400 text-xs gap-2">
        <div>
          2026 © TronicGen, Inc. All rights reserved. <span className="hidden md:inline">|</span> <span className="ml-1">Made with <span className="text-red-400">♥</span> for education</span>
        </div>
        <div className="flex gap-4 mt-2 md:mt-0">
          <Link to="/privacy" className="hover:underline">Privacy Policy</Link>
          <span>|</span>
          <Link to="#" className="hover:underline">Terms & Conditions</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
